import { makeVar } from '@grandvisionhq/graphql';

const cartCountVar = makeVar(0);

export { cartCountVar };
//# sourceMappingURL=cart-count-var.js.map
